"use client";

import DynamicIcon from "./DynamicIcon";

interface TechnicalSpecsGridProps {
  title: string;
  columns?: number;
  fields: {
    icon: string;
    label: string;
    value?: string;
  }[];
}

export default function TechnicalSpecsGrid({
  title,
  columns = 2,
  fields,
}: TechnicalSpecsGridProps) {
  return (
    <section className="py-24 bg-muted/30 border-y border-border/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tighter">{title}</h2>
        </div>

        <div
          className={`grid grid-cols-1 ${columns === 2 ? "md:grid-cols-2" : "md:grid-cols-1"} gap-4 max-w-4xl mx-auto`}
        >
          {/* If 2 columns, we split the fields into two cards for better visual balance */}
          <div className="bg-background rounded-2xl border border-border p-8 shadow-sm">
            <ul className="space-y-4">
              {fields
                .slice(0, Math.ceil(fields.length / (columns === 2 ? 2 : 1)))
                .map((field, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-0.5 text-primary">
                      <DynamicIcon name={field.icon} className="w-5 h-5" />
                    </div>
                    <div>
                      <span className="font-semibold block text-foreground">{field.label}</span>
                      {field.value && (
                        <span className="text-sm text-muted-foreground">{field.value}</span>
                      )}
                    </div>
                  </li>
                ))}
            </ul>
          </div>

          {columns === 2 && (
            <div className="bg-background rounded-2xl border border-border p-8 shadow-sm">
              <ul className="space-y-4">
                {fields.slice(Math.ceil(fields.length / 2)).map((field, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-0.5 text-primary">
                      <DynamicIcon name={field.icon} className="w-5 h-5" />
                    </div>
                    <div>
                      <span className="font-semibold block text-foreground">{field.label}</span>
                      {field.value && (
                        <span className="text-sm text-muted-foreground">{field.value}</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
